/**
 * VerticalEllipsisIcon component - renders a vertical ellipsis (three dots) icon as SVG
 * @returns React component that renders the vertical ellipsis icon
 */
const VerticalEllipsisIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4962 16.8C10.0618 16.8 9.69141 16.6453 9.38516 16.336C9.07891 16.0267 8.92578 15.6548 8.92578 15.2204C8.92578 14.7859 9.08044 14.4156 9.38975 14.1093C9.69906 13.8031 10.0709 13.65 10.5054 13.65C10.9398 13.65 11.3102 13.8046 11.6164 14.1139C11.9227 14.4232 12.0758 14.7951 12.0758 15.2295C12.0758 15.664 11.9211 16.0343 11.6118 16.3406C11.3025 16.6468 10.9306 16.8 10.4962 16.8ZM10.4962 12.075C10.0618 12.075 9.69141 11.9203 9.38516 11.611C9.07891 11.3017 8.92578 10.9298 8.92578 10.4954C8.92578 10.0609 9.08044 9.69058 9.38975 9.38433C9.69906 9.07808 10.0709 8.92495 10.5054 8.92495C10.9398 8.92495 11.3102 9.07961 11.6164 9.38892C11.9227 9.69823 12.0758 10.0701 12.0758 10.5045C12.0758 10.939 11.9211 11.3093 11.6118 11.6156C11.3025 11.9218 10.9306 12.075 10.4962 12.075ZM10.4962 7.34995C10.0618 7.34995 9.69141 7.19529 9.38516 6.88598C9.07891 6.57667 8.92578 6.20479 8.92578 5.77036C8.92578 5.33592 9.08044 4.96558 9.38975 4.65933C9.69906 4.35308 10.0709 4.19995 10.5054 4.19995C10.9398 4.19995 11.3102 4.35461 11.6164 4.66392C11.9227 4.97323 12.0758 5.34511 12.0758 5.77955C12.0758 6.21398 11.9211 6.58433 11.6118 6.89058C11.3025 7.19683 10.9306 7.34995 10.4962 7.34995Z"
        fill="#616161"
      />
    </svg>
  );
};

export default VerticalEllipsisIcon;
